import { render, staticRenderFns } from "./ConformationDialog.vue?vue&type=template&id=7516c70b"
import script from "./ConformationDialog.vue?vue&type=script&lang=js"
export * from "./ConformationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports